import React, {FC, useEffect, useState} from "react";
import {Drawer, Table, notification,} from "antd";
import {getVersionsForView, revert} from "../../admin-content-management/actions";
import * as dayjs from "dayjs";

const VersionListModal: FC = (props: any) => {
    const [isLoading, setIsLoading] = useState(true);
    const [versionList, setVersionList] = useState<any>([]);
    const [activeVersion, setActiveVersion] = useState<any>([]);

    const dateFormat = 'DD.MM.YYYY - HH:mm';

    const rollBack = (item: any) => {
        setIsLoading(true);

        revert({
            versionId: item.key,
            contentKey: props.content?.id
        }, props.locale)
            .then(
                () => {
                    notification['success']({
                        message: `Контент успешно изменен на версию от ${dayjs(item.timestamp).format(dateFormat)}`
                    });
                    props.onClose();
                }
            )
            .finally(
                () => setIsLoading(false)
            )
    };

    const columns = [
        {
            title: 'Версия',
            dataIndex: 'version',
            key: 'version',
        },
        {
            title: 'Действия',
            key: 'actions',
            render: (_, item) => activeVersion.id !== item.key
                && (
                    <a href='javascript:void(0)' onClick={() => rollBack(item)}>
                        Откатить
                    </a>
                )
        },
    ];

    useEffect(() => {
        setIsLoading(true);

        if (props.open) {
            getVersionsForView({
                contentId: props.content?.id,
                size: -1
            }, props.locale)
                .then(
                    value => {
                        setVersionList(value.data?.contentVersions
                            .filter(x => !x.path.includes('__unnamed__'))
                            .map(x => ({
                                key: x.id,
                                version: `${dayjs(x.timestamp).format(dateFormat)} от ${x.modifierDisplayName}`,
                            })
                        ));

                        setActiveVersion(value.data?.activeVersion?.contentVersion);
                    }
                )
                .finally(
                    () => setIsLoading(false)
                )
        }
    }, [props.open]);

    return (
        <Drawer
            title="Версия"
            placement="right"
            open={props.open}
            getContainer={false}
            onClose={props.onClose}
            size='large'
        >
            <Table dataSource={versionList} columns={columns} loading={isLoading} />
        </Drawer>
    );
};

export default VersionListModal;
